"use strict";exports.joinIfTruthy=function(o,t){return void 0===t&&(t=" "),o.filter(Boolean).join(t)};
//# sourceMappingURL=joinIfTruthy.cjs.map
